import { motion } from "framer-motion";
import styled from "styled-components";

import { H3, P1 } from "@/Components";
import { NO_SYMBOL, useConfig } from "@/hooks/useConfig";

const TotalsContianer = styled.div`
  margin: 10px 6px;
  margin-bottom: 30px;
`;
const TotalsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => (props.columns ? props.columns : 1)}, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
`;

const TotalItemWrapper = styled(motion.div)``;

const TotalValues = ({ total = 0, title = "", columns = 3, formatCurrency }) => {
  const {
    config,
    config: { showReturnInsteadOfRevenue },
  } = useConfig();
  const formatOptions = showReturnInsteadOfRevenue ? NO_SYMBOL : {};
  try {
    const values = [
      {
        label: `Total ${showReturnInsteadOfRevenue ? "return" : "sales"} driven by Brand Equity`,
        value: formatCurrency(total, formatOptions),
      },
    ];
    return (
      <TotalsContianer>
        <P1 margin={10} fSize={10} fweight={600}>
          {title || "Brand Equity Summary"}
        </P1>
        <TotalsWrapper columns={columns}>
          {values.map((item, index) => (
            <TotalItemWrapper key={index}>
              <H3 margin={10} fSize={28} fWeight={600}>
                {item.value}
              </H3>
              <P1 margin={10} fSize={11} fWeight={100}>
                {item.label}
              </P1>
            </TotalItemWrapper>
          ))}
        </TotalsWrapper>
      </TotalsContianer>
    );
  } catch (error) {
    return <></>;
  }
};

export default TotalValues;
